import { CLIENTS_ACTIONS } from 'constants/Actions/Clients';

// Estado inicial del reducer
const aInitialState = {
    aClients: [],
    nTotalPages: 0,
    oClient: null,
    nClientId: null,
    bIsSuccess: false,
    bIsError: false,

    aClientsSuggestion: [],
}
/**
 * Reducer que sera utilizado para controlar los datos referidos a los clientes del sistema.
 * 
 * @param {Array} aState Estado, si no recibe datos se setea el estado inicial
 * @param {object} oAction Action que es ejecutada
 * 
 * @returns {Array} Retorna un array que sera seteado en el estado del reducer
 * 
 * @author Leandro Curbelo 
 */
export const ClientReducer = (aState = aInitialState, oAction) => {
    switch (oAction.type) {
        case CLIENTS_ACTIONS.GET_ALL:
            return { ...aState, aClients: oAction.data.data, nTotalPages: oAction.data.pages };
        case CLIENTS_ACTIONS.GET_ACTIVE:
            return { ...aState, aClients: oAction.data.data, nTotalPages: oAction.data.pages };
        case CLIENTS_ACTIONS.FIND:
            return { ...aState, oClient: oAction.data };
        case CLIENTS_ACTIONS.SUCCESS:
            return { ...aState, bIsSuccess: true };
        case CLIENTS_ACTIONS.ADD:
            return { ...aState, bIsSuccess: true, nClientId: oAction.data };
        case CLIENTS_ACTIONS.ERROR:
            return { ...aState, bIsError: true };
        case CLIENTS_ACTIONS.CLEAN:
            return { ...aState, oClient: null, bIsSuccess: false, bIsError: false, nClientId: null };
        case CLIENTS_ACTIONS.SUGGESTION:
            return { ...aState, aClientsSuggestion: oAction.data };
        case CLIENTS_ACTIONS.SUGGESTION_CLEAN:
            return { ...aState, aClientsSuggestion: [] };
        default:
            return aState;
    }
}
